import script from "./EventAggregate.vue?vue&type=script&setup=true&lang=js"
export * from "./EventAggregate.vue?vue&type=script&setup=true&lang=js"

import "./EventAggregate.vue?vue&type=style&index=0&id=b03b7cbc&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b03b7cbc"]])

export default __exports__